module.exports = __webpack_public_path__ + "static/media/harmon-hall-white.7245037a.svg";